export default __webpack_public_path__ + "static/media/N_Forms.ce9b97ac.png";